import { NavigateFunction } from "react-router-dom";




const navigateToEmployeeList = (router: NavigateFunction) => {
    router("/human-resources/employees")
}


const navigateToEmployeeDetails = (router: NavigateFunction, empId: string) => {
    router(`/human-resources/employees/employee?empId=${empId}`)
}

const navigateToManualList = (router: NavigateFunction) => {
    router(`/manuals`)
}

// Opens a user manual (api/manuals/<slug>.md) in the portal
// slug is "<module>/<name>", e.g. "human-resources/employees" → /manuals/human-resources/employees
const navigateToManual = (router: NavigateFunction, slug: string) => {
    router(`/manuals/${slug}`)
}

// Print view of a manual in a new tab (opens the print dialog once loaded)
const openManualPrint = (slug: string) => {
    window.open(`/manuals/${slug}/print`, "_blank")
}

const navigateToHome = (router: NavigateFunction) => {
    router("/");
}

// Goes back in history when there's somewhere to go back to (i.e. navigated in from
// elsewhere in the app); falls back to home for a direct/deep link with no in-app history.
const navigateBackOrHome = (router: NavigateFunction) => {
    if (window.history.length > 1) {
        router(-1)
    } else {
        navigateToHome(router)
    }
}

// Back one step when this tab has app history to return to, otherwise `fallback`.
// history.state.idx is React Router's position in its own stack -- 0 when the app was opened on this page.
const navigateBackOr = (router: NavigateFunction, fallback: () => void) => {
    if ((window.history.state?.idx ?? 0) > 0) {
        router(-1)
    } else {
        fallback()
    }
}

const navigateToGenerator =(router: NavigateFunction, documnetId: string, draftId?: string) => {
    router(`/human-resources/document-generator/generate?docId=${documnetId}${draftId ? `&genDocId=${draftId}` : ''}`)
}

const navigateToApprover = (router: NavigateFunction, genDocId: string) => {
    router(`/human-resources/document-generator/approve?genDocId=${genDocId}`)
}

const navigateToSearchDocuments = (router: NavigateFunction) => {
    router("/human-resources/document-generator/search");
}

const navigateToGeneratedDocuments = (router: NavigateFunction) => {
    router("/human-resources/document-generator");
}

const navigateToCreateConsultants = (router: NavigateFunction) => {
    router("/human-resources/consultants/create")
}

const navigateToEditConsultants = (router: NavigateFunction, empId: string) => {
    router(`/human-resources/consultants/edit?consultantId=${empId}`)
}

const navigateToProjectDetails = (router: NavigateFunction, projectId: string) => {
    router(`/project-managment/projects/project?projectId=${projectId}`)
}

const navigateToProjectList = (router: NavigateFunction) => {
    router(`/project-managment/projects`)
}


const navigateToProfile = (router: NavigateFunction) => {
    router(`/profile`)
}

const navigateToCreateRocks = (router: NavigateFunction) => {
    router(`/business-development/rocks/create`)
}

const navigateToEditRocks = (router: NavigateFunction, rockId: string) => {
    router(`/business-development/rocks/edit?rockId=${rockId}`)
}

const navigateToClientDetails = (router: NavigateFunction, clientId: string) => {
    router(`/business-development/client/details?clientId=${clientId}`)
}

const navigateToClientList = (router: NavigateFunction) => {
    router(`/business-development/client`)
}

const navigateToCreateClientEngagement = (router: NavigateFunction) => {
    router("/business-development/client-engagement/create")
}

const navigateToEditClientEngagement = (router: NavigateFunction, clientEngagementId: string) => {
    router(`/business-development/client-engagement/edit?clientEngagementId=${clientEngagementId}`)
}

const navigateToCreateIndustryEngagement = (router: NavigateFunction) => {
    router("/business-development/industry-engagement/create")
}

const navigateToEditIndustryEngagement = (router: NavigateFunction, industryEngagementId: string) => {
    router(`/business-development/industry-engagement/edit?industryEngagementId=${industryEngagementId}`)
}

const navigateToConsultantAgreement = (router: NavigateFunction, docId: string, genDocId?: string) => {
    router(`/human-resources/document-generator/consultant-agreement?docId=${docId}${genDocId ? `&genDocId=${genDocId}` : ''}`)
}

const navigateToDepartments = (router: NavigateFunction) => {
    router("/admin/departments")
}

const navigateToCreateDepartment = (router: NavigateFunction) => {
    router("/admin/departments/create")
}

// Admin > System Updates Memo detail; slug is the file name without .md (e.g. 2026-11-01-new-expense-budgets)
const navigateToMemoDetails = (router: NavigateFunction, slug: string) => {
    router(`/admin/system-updates-memo/details?slug=${encodeURIComponent(slug)}`)
}

const navigateToMemoList = (router: NavigateFunction) => {
    router(`/admin/system-updates-memo`)
}

const navigateToLambdaTrackerDetails = (router: NavigateFunction, id: string, days?: number) => {
    router(`/admin/lambda-tracker/details?id=${id}${days ? `&days=${days}` : ""}`)
}

const navigateToDepartmentDetails = (router: NavigateFunction, departmentId: string) => {
    router(`/admin/departments/details?departmentId=${departmentId}`)
}

const navigateToEditDepartment = (router: NavigateFunction, departmentId: string) => {
    router(`/admin/departments/edit?departmentId=${departmentId}`)
}

const navigateToCreateDepartmentKPI = (router: NavigateFunction, departmentId: string) => {
    router(`/admin/departments/kpi/create?departmentId=${departmentId}`)
}

const navigateToEditDepartmentKPI = (router: NavigateFunction, departmentId: string, branchId: string, fiscalYear: number) => {
    router(`/admin/departments/kpi/edit?departmentId=${departmentId}&branchId=${branchId}&fiscalYear=${fiscalYear}`)
}

// Department KPIs module (all departments); optional department pre-selects the filter
const navigateToDepartmentKPIs = (router: NavigateFunction, departmentId?: string) => {
    router(`/admin/department-kpis${departmentId ? `?departmentId=${departmentId}` : ''}`)
}

const navigateToContinuingEducationList = (router: NavigateFunction) => {
    router("/forms/continuing-education")
}

const navigateToCreateContinuingEducation = (router: NavigateFunction) => {
    router("/forms/continuing-education/create")
}

const navigateToContinuingEducationDetails = (router: NavigateFunction, id: string) => {
    router(`/forms/continuing-education/${id}`)
}

const navigateToEditContinuingEducation = (router: NavigateFunction, id: string) => {
    router(`/forms/continuing-education/edit/${id}`)
}

const openContinuingEducationPrint = (id: string) => {
    window.open(`/forms/continuing-education/print/${id}`, "_blank")
}

const navigateToExpenseBudgets = (router: NavigateFunction) => {
    router("/finance/expense-budgets")
}

const navigateToExpenseBudgetDetails = (router: NavigateFunction, expenseBudgetId: string) => {
    router(`/finance/expense-budgets/details?expenseBudgetId=${expenseBudgetId}`)
}

export {
    navigateToSearchDocuments,
    navigateToEmployeeDetails,
    navigateToManual,
    navigateToManualList,
    openManualPrint,
    navigateToCreateConsultants,
    navigateToEditConsultants,
    navigateToEmployeeList,
    navigateToGenerator,
    navigateToApprover,
    navigateToGeneratedDocuments,
    navigateToHome,
    navigateToProjectDetails,
    navigateToProjectList,
    navigateToProfile,
    navigateToCreateRocks,
    navigateToEditRocks,
    navigateToClientDetails,
    navigateToClientList,
    navigateToCreateClientEngagement,
    navigateToEditClientEngagement,
    navigateToCreateIndustryEngagement,
    navigateToEditIndustryEngagement,
    navigateToConsultantAgreement,
    navigateToDepartments,
    navigateToCreateDepartment,
    navigateToDepartmentDetails,
    navigateToLambdaTrackerDetails,
    navigateToMemoDetails,
    navigateToMemoList,
    navigateToEditDepartment,
    navigateToCreateDepartmentKPI,
    navigateToEditDepartmentKPI,
    navigateToDepartmentKPIs,
    navigateToContinuingEducationList,
    navigateToCreateContinuingEducation,
    navigateToContinuingEducationDetails,
    navigateToEditContinuingEducation,
    openContinuingEducationPrint,
    navigateToExpenseBudgets,
    navigateToExpenseBudgetDetails,
    navigateBackOrHome,
    navigateBackOr
}